import React from "react";
import { createBrowserRouter } from "react-router-dom";
import RootLayout from "./layouts/Root";

import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/Privacy";
import ResetPassword from "./pages/ResetPassword";
import Service from "./pages/Service";
import Signup from "./pages/Signup";
import Terms from "./pages/Terms";
import VerifyEmail from "./pages/VerifyEmail";

import ProtectedLayout from "./pages/_Protected/Layout";
import ProtectedHome from "./pages/_Protected/Home";
import Documents from "./pages/_Protected/Documents";
import Payments from "./pages/_Protected/Payments";
import Profile from "./pages/_Protected/Profile";
import Transactions from "./pages/_Protected/Transactions";
import TransactionDetail from "./pages/_Protected/Transactions/Detail";
import NewTransaction from "./pages/_Protected/Transactions/New";
import Deals from "./pages/_Protected/Deals";
import DealDetail from "./pages/_Protected/Deals/Detail";
import Certificate from "./pages/_Protected/Certificate";
import Support from "./pages/_Protected/Support";
import KYCStep1 from "./pages/_Protected/KYC/Step1";
import KYCStep2 from "./pages/_Protected/KYC/Step2";
import KYCStep3 from "./pages/_Protected/KYC/Step3";
import KYCStep4 from "./pages/_Protected/KYC/Step4";
import KYCStep5 from "./pages/_Protected/KYC/Step5";
import KYCStep6 from "./pages/_Protected/KYC/Step6";
import KYCStep7 from "./pages/_Protected/KYC/Step7";
import KYCSuccess from "./pages/_Protected/KYC/Success";
import ProtectedNotFound from "./pages/_Protected/NotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "blog",
        element: <Blog />,
      },
      {
        path: "service",
        element: <Service />,
      },
      {
        path: "faq",
        element: <Faq />,
      },
      {
        path: "privacy",
        element: <Privacy />,
      },
      {
        path: "terms",
        element: <Terms />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
  },
  {
    path: "/d",
    element: <ProtectedLayout />,
    children: [
      {
        index: true,
        element: <ProtectedHome />,
      },
      {
        path: "new-transaction",
        element: <NewTransaction />,
      },
      {
        path: "transactions",
        children: [
          {
            index: true,
            element: <Transactions />,
          },
          {
            path: ":id",
            element: <TransactionDetail />,
          },
        ],
      },
      {
        path: "deals",
        children: [
          {
            index: true,
            element: <Deals />,
          },
          {
            path: ":id",
            element: <DealDetail />,
          },
        ],
      },
      {
        path: "documents",
        element: <Documents />,
      },
      {
        path: "payments",
        element: <Payments />,
      },
      {
        path: "cert/:certID",
        element: <Certificate />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "kyc",
        children: [
          {
            path: "step1",
            element: <KYCStep1 />,
          },
          {
            path: "step2",
            element: <KYCStep2 />,
          },
          {
            path: "step3",
            element: <KYCStep3 />,
          },
          {
            path: "step4",
            element: <KYCStep4 />,
          },
          {
            path: "step5",
            element: <KYCStep5 />,
          },
          {
            path: "step6",
            element: <KYCStep6 />,
          },
          {
            path: "step7",
            element: <KYCStep7 />,
          },
          {
            path: "success",
            element: <KYCSuccess />,
          },
        ],
      },
      {
        path: "settings",
        element: <Profile />,
      },
      {
        path: "*",
        element: <ProtectedNotFound />,
      },
    ],
  },
]);

export default router;
